import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.5 4C9.56087 4 10.5783 4.42143 11.3284 5.17157C12.0786 5.92172 12.5 6.93913 12.5 8C12.5 9.06087 12.0786 10.0783 11.3284 10.8284C10.5783 11.5786 9.56087 12 8.5 12C7.43913 12 6.42172 11.5786 5.67157 10.8284C4.92143 10.0783 4.5 9.06087 4.5 8C4.5 6.93913 4.92143 5.92172 5.67157 5.17157C6.42172 4.42143 7.43913 4 8.5 4Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.0355 4.46447C11.0979 3.52678 9.82608 3 8.5 3C7.17392 3 5.90215 3.52678 4.96447 4.46447C4.02678 5.40215 3.5 6.67392 3.5 8C3.5 9.32608 4.02678 10.5979 4.96447 11.5355C5.90215 12.4732 7.17392 13 8.5 13C9.82608 13 11.0979 12.4732 12.0355 11.5355C12.9732 10.5979 13.5 9.32608 13.5 8C13.5 6.67392 12.9732 5.40215 12.0355 4.46447Z",
		stroke: "currentColor",
		strokeOpacity: .3,
		strokeWidth: 2
	})]
});
export default SvgDotIcon;
